import { useEffect } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { RouterProvider } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { PrismicProvider } from "@prismicio/react";
import router from "./routes/appRoutes";
import phioTheme from "./themes/phioTheme";
import { client } from "../src/utils/prismic/prismic";
import { NotificationProvider } from "./components/Notification";
import { SkipLinkProvider, SkipLink, useSkipLink } from "./components/SkipLink";
import { setUserProperty } from "./services/analitics/FbAnalytics";

function AppContent() {
    const { setSkipLink } = useSkipLink();

    useEffect(() => {
        // Set default skip link that focuses h1 heading
        const defaultSkipLink = {
            title: "Skip to main content",
            onClick: () => {
                // Try to find h1 first (preferred for screen readers)
                const h1 = document.querySelector('main h1, h1');
                if (h1) {
                    const h1Element = h1 as HTMLElement;
                    h1Element.setAttribute('tabindex', '-1');
                    h1Element.focus();
                    h1Element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                } else {
                    // Fallback to main if no h1 found
                    const main = document.querySelector('main');
                    if (main) {
                        main.setAttribute('tabindex', '-1');
                        main.focus();
                        main.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }
            },
        };

        setSkipLink(defaultSkipLink);

        return () => {
            setSkipLink(null);
        };
    }, [setSkipLink]);

    return (
        <PrismicProvider client={client}>
            <RouterProvider router={router} />
        </PrismicProvider>
    );
}

function App() {
    useEffect(() => {
        setUserProperty({ application: "genphlo" });
    }, []);

    return (
        <HelmetProvider>
            <ThemeProvider theme={phioTheme}>
                <CssBaseline />
                <NotificationProvider>
                    <SkipLinkProvider>
                        <SkipLink />
                        <AppContent />
                    </SkipLinkProvider>
                </NotificationProvider>
            </ThemeProvider>
        </HelmetProvider>
    );
}

export default App;
